import styled, {keyframes} from 'styled-components'
import { Image } from './Image'

import padlock from '../../../../assets/images/card2.0/open-padlock.svg'
import { Text } from './Text'
import { BodyFrontContainer, CardGroup, HeaderCardGroup, HeaderContainer } from './Container'
import {devices} from '../../../../components/MediaQuerys/BreakpointsAndDevices'



const FlipCardContainer = styled.div`
    height: 100%;
    position: absolute;
    right: 0;
    transform-origin: left;
    transform-style: preserve-3d;
    transition: all 1s ease;
    width: 100%;
`
const FlipCard = styled.div`
    perspective: 100rem;
    position: absolute;
    right: 0;
    transition: all 1s ease;
    visibility: hidden;
    width: 25rem;
    height: 15rem;
    z-index: 100;
    * {
        visibility: visible;
    }
`
const CardFront = styled.div`
    background-color: #dfe4ea;
    backface-visibility: hidden;
    height: 15rem;
    width: 25rem;
    border-radius: 10px 10px 10px 0;
`
const CardBack = styled.div`
    background-color: #dfe4ea;
    border-radius: 10px 0 0 10px;
    transform: rotateY(180deg);
    backface-visibility: hidden;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 25rem;
    padding: 1rem;
`
const InsidePage = styled.div`
    background-color: #dfe4ea;
    border-radius: 10px 10px 10px 0;
    box-shadow: inset 4rem 0px 5rem -4rem rgba(0,0,0,0.25);
    height: 100%;
    padding: 1rem 1rem;
    position: absolute;
    right: 0;
    transition: all 3s ease;
    width: 25rem;
    z-index: 1;
    overflow-y: scroll;
    &::-webkit-scrollbar{
        background-color: rgb(211, 211, 211);
        border-radius: 20px;
        width: 10px;
    }
    &::-webkit-scrollbar-thumb{
        background-color: rgb(59, 59, 59);
        border-radius: 20px;
    }
`
const CardContainer = styled.div`
    background-color: transparent;
    border-radius: 10px;
    box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px;
    height: 15rem;
    width: 25rem;
    position: relative;
    transition: all 0.5s ease;


    &:hover ${InsidePage}{
        border-radius: 0 10px 10px 0;
    }
    @media only screen and ${devices.mobileS} {
        /* width:320px; */
        
    }
    @media only screen and ${devices.mobileM} {
        /* width:98%; */
        
    }
    @media only screen and ${devices.tablet} {
        &:hover{
        background-color: #dfe4ea;
        box-shadow:-.1rem 1.7rem 6.6rem -3.2rem rgba(0,0,0,0.75);
        width: 50rem;
        }
        &:hover ${FlipCardContainer}{
        transform: rotateY(-180deg);
        }
    }
    @media only screen and ${devices.laptop}{
        /* width: 98%; */

    }
    @media only screen and ${devices.laptopL}{
        /* width:1440px; */

    }
`
const VideoComponent  = styled.video`
    border-radius: 10px;
    height: 13em;
    min-height: 100%;
    object-fit: scale-down;
    width: 100%;
    opacity: ${props => props.opacity};
`
const Source = styled.source``

const Video = (props)=>{
    return(
        <VideoComponent
            onMouseEnter={event => event.target.play(event.muted=false)}
            onMouseOut={event => event.target.pause()}
            controls
            muted>
            <Source 
                src={props.video}
                type='video/mp4'/>
        </VideoComponent>
    )
}
const upDownAnimation = keyframes`
50% {
    margin-left: -20px;
}
`
const RegisterButtonComponent = styled.button`
    border: none;
    cursor: pointer;
    background-color: #2ECC71;
    border-radius: 0.8em 0 0 0.8em;
    color: #222f3e;
    font-size:0.9em;
    font-family: 'Montserrat-Medium';
    width: 7rem;
    height: 2rem;
    position: absolute;
    right: 0;
    top: 0;
    transition: all 0.2s ease-in-out;
    display: ${props => props.display};
    &:hover{
        border: none;
        background-color: #36e780;
        font-size:1.8em;
        font-family: 'Montserrat-Bold';
        height: 2em;
        width: 100%;
        border-radius: 0;
        transition: all 0.2s ease-in-out;
    }
    &::before{
        content:'👇';
        font-size: 2em;
        position: absolute;
        left: -1.5em;
        top: -0.2em;
        transform: rotateZ(-90deg);
        animation: ${upDownAnimation} 1s infinite;
    }
`
const RegisterButton = (props)=>{
    return(
        <RegisterButtonComponent
            display={props.display}
            onClick={props.onClick}>
            <Text text='Regístrese'/> 
        </RegisterButtonComponent>
    )
}
export const CourseCard2 = (props) => {
    return (
        <CardContainer>
            <FlipCard>
                <FlipCardContainer>
                    <CardFront>
                        <HeaderContainer backgroundColor={props.backgroundColorHeader}>
                            <Text text={props.area} color='#EFF1F3'fontSize='1em' fontFamily='Montserrat-Bold' />
                            <HeaderCardGroup>
                                <Text text={props.capacity} color='#EFF1F3'fontSize='1em'fontFamily='Montserrat-Regular' />
                                <Image src={padlock}/>
                            </HeaderCardGroup>
                        </HeaderContainer>
                        <BodyFrontContainer>
                            <CardGroup>
                                <Text text={props.type} color='#747d8c'fontSize='0.9em' fontFamily='Montserrat-Bold'/>
                                <Text text={props.course} color='#0c2461'fontSize='1em' fontFamily='Montserrat-Bold'/>
                                <Text text={props.description} color='#0c2461'fontSize='0.89em' fontFamily='Montserrat-Regular'/>
                            </CardGroup>
                        </BodyFrontContainer>
                    </CardFront>
                    <CardBack>
                        <Video video={props.video}/>
                    </CardBack>
                </FlipCardContainer>
            </FlipCard>
            <InsidePage>
                <CardGroup>
                    <RegisterButton
                        display={props.display}
                        onClick={props.onClick}/>
                    <Text text='DOCENTE' color='#747d8c'fontSize='0.9em' fontFamily='Montserrat-Bold'/>
                    <Text text={props.teacher} color='#0c2461'fontSize='1em' fontFamily='Montserrat-Bold'/>
                    <Text text='POBLACIÓN' color='#747d8c'fontSize='0.9em' fontFamily='Montserrat-Bold'/>
                    <Text text={props.population} color='#0c2461'fontSize='0.9em' fontFamily='Montserrat-Regular'/>
                    <Text text='HORARIOS' color='#747d8c'fontSize='0.9em' fontFamily='Montserrat-Bold'/>
                    <Text text={props.schedule} color='#0c2461'fontSize='0.9em' fontFamily='Montserrat-Regular'/>
                    <Text text='REQUISITOS' color='#747d8c'fontSize='0.9em' fontFamily='Montserrat-Bold'/>
                    <Text text={props.requirements} color='#0c2461'fontSize='0.85em' fontFamily='Montserrat-Regular'/>
                    
                </CardGroup>
            </InsidePage>
        </CardContainer>
    )
}